import React, { useState } from "react";
import KanbanBoard from "./KanbanBoard";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { IoChevronBackOutline } from "react-icons/io5";
import "./Board.scss";
const Board = () => {
  const [BoardName, SetBoardName] = useState("");

  const { id } = useParams();
  return (
    <div>
      <Header>
        <Link to="/StatusBoard">
          <IoChevronBackOutline size={20} />
        </Link>
        <TextHeader>{BoardName} Board</TextHeader>
      </Header>
      <KanbanBoard id={id} SetBoardName={SetBoardName} />
    </div>
  );
};

export default Board;
const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 1.5rem;
  a {
    text-decoration: none;
  }
  padding-top: 1rem;
`;
const TextHeader = styled.h4`
  font-family: sans-serif;
`;
